export function removeExtraInfo(content) {
  if (typeof content !== 'string') return content;
  let displayContent = content.replace(/\n?\([^)]*\)/g, '');
  displayContent = displayContent.replace(/\n?\([^)]*- [^)]*\)/g, '');
  return displayContent.split('\n')[0].trim();
} 